export default __webpack_public_path__ + "static/media/curved8.80b992f8.jpg";